/* =========================================================
   Floating buttons — hide on scroll
   ---------------------------------------------------------
   Toggles `data-wt-float-hidden` on <html> so the shared CSS
   (snippets/floating-buttons.liquid) can fade the whole right-side
   stack out of the way while the visitor scrolls down, and bring it
   back as soon as they scroll up again.
   Never hides while the ChatWill panel is open, so an open chat is
   never yanked off screen.
   ========================================================= */
(function () {
  const script = document.currentScript;
  const distance = parseFloat(script && script.dataset.wtFloatDistance) || 300;
  const root = document.documentElement;

  let lastY = window.scrollY;
  let hidden = false;
  let ticking = false;

  function panelOpen() {
    if (document.querySelector('#willlink-app .willlink-iframe-container.active')) return true;
    // Mobile full-screen form of the panel (the app toggles this class instead of .active
    // in some layouts) plus its "mobile view" host state.
    if (document.querySelector('#willlink-app .willlink-iframe-container.mobile-view')) return true;
    if (document.querySelector('.mobile-view-active')) return true;
    // The close button is only shown while the panel is open — last-resort signal.
    return !!document.querySelector('#willlink-app .willlink-close-btn.visible');
  }

  function setHidden(next) {
    if (next === hidden) return;
    hidden = next;
    if (next) {
      root.setAttribute('data-wt-float-hidden', 'true');
    } else {
      root.removeAttribute('data-wt-float-hidden');
    }
  }

  function update() {
    const y = window.scrollY;

    if (y <= distance || panelOpen()) {
      // Above the threshold, or the chat panel is open: always show the stack.
      setHidden(false);
    } else if (y > lastY) {
      // Scrolling down past the threshold: get out of the way.
      setHidden(true);
    } else if (y < lastY) {
      // Scrolling up: bring the stack back.
      setHidden(false);
    }

    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // The panel opens and closes on click, not on scroll, so re-evaluate right after a
  // click (the second pass runs once the app's open/close transition has finished).
  document.addEventListener('click', function () {
    requestAnimationFrame(update);
    setTimeout(update, 350);
  }, true);

  update();
})();
